/* Babbez — scroll reveal (fail-safe: no JS => nothing hidden) */
(function () {
  var els = document.querySelectorAll('[data-bz]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  for (var i = 0; i < els.length; i++) els[i].classList.add('bz-anim');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px 18% 0px', threshold: 0.01 });
  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();


/* ===== Babbez — collection colour-swatch preview (hover/click swaps the card's main image) ===== */
(function () {
  function mainImg(card) {
    var box = card.querySelector('[data-product-image-default]');
    return box ? box.querySelector('img') : card.querySelector('.product-item__bg img, .product-item__image img');
  }
  function swap(card, url) {
    var img = mainImg(card);
    if (!img || !url) return;
    if (!card.dataset.bzOrig) { card.dataset.bzOrig = img.getAttribute('src') || ''; card.dataset.bzOrigSet = img.getAttribute('srcset') || ''; }
    img.setAttribute('srcset', ''); img.removeAttribute('sizes'); img.setAttribute('src', url);
    card.classList.add('bz-swatching');
  }
  function revert(card) {
    var img = mainImg(card);
    if (img) { if (card.dataset.bzOrig) img.setAttribute('src', card.dataset.bzOrig); if (card.dataset.bzOrigSet) img.setAttribute('srcset', card.dataset.bzOrigSet); }
    card.classList.remove('bz-swatching');
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest ? e.target.closest('.bz-sw') : null; if (!sw) return;
    var card = sw.closest('.product-item'); if (!card) return;
    swap(card, sw.getAttribute('data-bz-img'));
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest ? e.target.closest('.bz-sw') : null; if (!sw) return;
    var card = sw.closest('.product-item'); if (!card || card.dataset.bzLocked) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('.product-item') === card && to.closest('.bz-sw')) return;
    revert(card);
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('.bz-sw') : null; if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.product-item'); if (!card) return;
    swap(card, sw.getAttribute('data-bz-img'));
    card.dataset.bzLocked = '1';
    var sws = card.querySelectorAll('.bz-sw'); for (var i = 0; i < sws.length; i++) sws[i].classList.remove('is-active');
    sw.classList.add('is-active');
    var vurl = sw.getAttribute('data-bz-url');
    if (vurl) { var links = card.querySelectorAll('a.product-link'); for (var j = 0; j < links.length; j++) links[j].setAttribute('href', vurl); }
  });
})();


/* ===== Babbez PERF — mega-menu lazy hydration =====
   Desktop mega panels ship as EMPTY keyed <template data-bz-mega data-bz-megakey> (~100KB lighter
   HTML per page). On first intent we fetch the REAL header section via the Section Rendering API
   from /search?sections=<header-section-id> (search context renders full mega content, and the
   header instance renders with all its blocks — unlike a standalone data section). The fetched
   HTML is cached in sessionStorage so cross-page navigation costs nothing. Mobile drawer keeps
   its own data-bz-src endpoint. */
(function () {
  var bzNavPromise = null;
  var bzMegaPromise = null;
  function bzHeaderSid() {
    var t = document.querySelector('template[data-bz-megakey]');
    var sec = t && t.closest ? t.closest('.shopify-section') : null;
    return sec && sec.id ? sec.id.replace('shopify-section-', '') : null;
  }
  function bzFetchMega() {
    if (bzMegaPromise) return bzMegaPromise;
    var sid = bzHeaderSid();
    if (!sid) return Promise.reject();
    var ck = 'bzmega1:' + sid;
    var cached = null;
    try { cached = sessionStorage.getItem(ck); } catch (e) {}
    if (cached) {
      bzMegaPromise = Promise.resolve(new DOMParser().parseFromString(cached, 'text/html'));
      return bzMegaPromise;
    }
    bzMegaPromise = fetch('/search?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json[sid] || json[Object.keys(json)[0]];
        try { sessionStorage.setItem(ck, html); } catch (e) {}
        return new DOMParser().parseFromString(html, 'text/html');
      });
    bzMegaPromise.catch(function () { bzMegaPromise = null; });
    return bzMegaPromise;
  }
  function bzFillMega(t) {
    var k = t.getAttribute('data-bz-megakey');
    if (!k) return;
    bzFetchMega().then(function (doc) {
      var el = document.querySelector('template[data-bz-megakey="' + k + '"]');
      if (!el || !el.parentNode) return;
      var src = doc.querySelector('template[data-bz-megakey="' + k + '"]');
      if (!src || !src.content || !src.content.firstChild) { return; }
      el.parentNode.insertBefore(src.content.cloneNode(true), el);
      el.parentNode.removeChild(el);
    }).catch(function () {});
  }
  function bzFetchNav(t) {
    var src = t.getAttribute('data-bz-src');
    if (!src) return;
    if (!bzNavPromise) bzNavPromise = fetch(src, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    bzNavPromise.then(function (json) {
      var el = document.querySelector('template[data-bz-mega][data-bz-src]');
      if (!el || !el.parentNode) return;
      var key = Object.keys(json)[0];
      var doc = new DOMParser().parseFromString(json[key], 'text/html');
      var host = doc.querySelector('[data-bz-navdata]');
      if (!host) return;
      var frag = document.createDocumentFragment();
      while (host.firstChild) frag.appendChild(host.firstChild);
      el.parentNode.insertBefore(frag, el);
      el.parentNode.removeChild(el);
    }).catch(function () {});
  }
  function hydrate(scope) {
    var tpls = scope.querySelectorAll('template[data-bz-mega]');
    for (var i = 0; i < tpls.length; i++) {
      var t = tpls[i];
      if (t.getAttribute('data-bz-src')) { bzFetchNav(t); continue; }
      if (t.content && t.content.firstChild) {
        /* content present (e.g. /search context) => clone synchronously, identical to old flow */
        t.parentNode.insertBefore(t.content.cloneNode(true), t);
        t.parentNode.removeChild(t);
      } else if (t.getAttribute('data-bz-megakey')) {
        bzFillMega(t);
      }
    }
    return tpls.length;
  }
  /* prefetch drawer nav on the very first touch so the hamburger tap feels instant */
  document.addEventListener('touchstart', function () {
    var t = document.querySelector('template[data-bz-mega][data-bz-src]');
    if (t) bzFetchNav(t);
  }, { once: true, passive: true });
  function hydrateItem(e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-drawer-toggle],[data-popout-toggle]')) { hydrate(document); return; }
    var mi = e.target.closest('.menu__item');
    if (mi) hydrate(mi);
  }
  /* capture phase => runs before the theme's own open handlers */
  document.addEventListener('pointerenter', hydrateItem, true);
  document.addEventListener('pointerover', function bzWarm(e) {
    if (e.target && e.target.closest && e.target.closest('.menu__item, [data-header-wrapper], header')) {
      bzFetchMega();
      document.removeEventListener('pointerover', bzWarm, true);
    }
  }, true);
  document.addEventListener('pointerdown', hydrateItem, true);
  document.addEventListener('focusin', hydrateItem, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') { hydrate(document); }
  }, true);
  /* desktop: warm the cache during idle so even the first hover is instant */
  if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
    var warm = function () { bzFetchMega(); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 6000 });
    else setTimeout(warm, 4000);
  }
})();


/* ===== Babbez PERF — lazy country options =====
   The 4 country <select>s ship slim (current + popular). On first interaction we clone the full
   list from the shared <template data-bz-countries> so the native picker opens complete. */
(function () {
  function fill(sel) {
    if (sel.dataset.bzFilled) return;
    var tpl = document.querySelector('template[data-bz-countries]');
    if (!tpl || !tpl.content) return;
    var cur = sel.value;
    var frag = tpl.content.cloneNode(true);
    sel.innerHTML = '';
    sel.appendChild(frag);
    sel.value = cur;
    if (sel.selectedIndex < 0) sel.selectedIndex = 0;
    sel.dataset.bzFilled = '1';
  }
  ['pointerdown', 'focusin', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (!e.target || !e.target.closest) return;
      var sel = e.target.closest('select[data-bz-lazy-countries]');
      if (sel) fill(sel);
    }, true);
  });
})();
